import React, { FocusEvent, useCallback } from 'react';
import { ITextFieldProps } from '../../../../../../ui';
import { observer } from 'mobx-react';
import { Email } from '../../../../../auth/shared/form-fields/Email';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';
import { EmailSuggestionStore } from '../../../../domain/email-validation/stores/EmailSuggestionStore';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export type IEmailWithSuggestionProps = Partial<ITextFieldProps> & {
	store?: EmailSuggestionStore;
};

export const EmailWithSuggestion = observer(
	({ store, ...rest }: IEmailWithSuggestionProps) => {
		const {
			formState: { errors },
		} = useDetailsFormContext();
		const { t } = useTranslation();

		const onBlur = useCallback((event: FocusEvent<HTMLInputElement>) => {
			const email = event.currentTarget.value;
			const hasError = !!errors.email;

			if (hasError) {
				return;
			}

			if (email) {
				store?.load({ email });
			} else {
				store?.reset();
			}
		}, []);

		const warning = store?.suggestion
			? t('parking_details_form_email_suggestion_warning', {
					suggestion: store.suggestion,
			  })
			: undefined;

		return <Email {...rest} onBlur={onBlur} warning={warning} />;
	},
);
